// Motiv, velikost písma, hustota, tapeta – vše přes CSS proměnné (tokeny). Žádný zásah do komponent.
import { core } from './api';

export type ThemePref = 'auto' | 'light' | 'dark';

const root = document.documentElement;

export function applyTheme(theme: ThemePref): void {
  root.dataset.theme = theme;
  try {
    localStorage.setItem('iwan.theme', theme);
  } catch {
    /* ignore */
  }
}

export function currentTheme(): ThemePref {
  const t = root.dataset.theme;
  return t === 'light' || t === 'dark' ? t : 'auto';
}

export function isDark(): boolean {
  const t = currentTheme();
  if (t === 'dark') return true;
  if (t === 'light') return false;
  return window.matchMedia('(prefers-color-scheme: dark)').matches;
}

export function applyFontScale(scale: number): void {
  const s = Math.min(1.6, Math.max(0.85, scale));
  root.style.setProperty('--font-scale', String(s));
  try {
    localStorage.setItem('iwan.font', String(s));
  } catch {
    /* ignore */
  }
}

export function currentFontScale(): number {
  const v = parseFloat(getComputedStyle(root).getPropertyValue('--font-scale'));
  return Number.isFinite(v) && v > 0 ? v : 1;
}

export function applyDensity(density: 'compact' | 'normal' | 'comfortable'): void {
  root.dataset.density = density;
}

export function applyWallpaper(wallpaper: { url?: string | null; color?: string | null } | null): void {
  const layer = document.querySelector<HTMLElement>('.desktop-wallpaper');
  if (!layer) return;
  layer.style.backgroundImage = wallpaper?.url ? `url("${wallpaper.url}")` : '';
  layer.style.backgroundColor = wallpaper?.color ?? '';
  layer.classList.toggle('has-image', Boolean(wallpaper?.url));
}

/** Branding zákazníka: akcent a logo. Kontrast akcentu se hlídá – příliš světlá barva se ztmaví. */
export function applyBranding(branding: Record<string, unknown>): void {
  const accent = typeof branding['accent'] === 'string' ? branding['accent'] : null;
  if (accent && /^#[0-9a-f]{6}$/i.test(accent)) {
    root.style.setProperty('--brand-custom', accent);
    root.dataset.branded = '1';
  } else {
    root.style.removeProperty('--brand-custom');
    delete root.dataset.branded;
  }
}

/** Uloží preferenci na server (per uživatel) i lokálně pro okamžitý start příští záložky. */
export async function savePref(key: string, value: unknown): Promise<void> {
  const w = window as unknown as { iwanPrefs?: Record<string, unknown> };
  if (w.iwanPrefs) w.iwanPrefs[key] = value;
  try {
    await core('prefs', 'set', { key, value });
  } catch (e) {
    console.warn('pref', key, e);
  }
}
